// The one in-memory query cache. It lives apart from the app root so the session store can discard it: nothing fetched
// before a lock or a session end may be shown after it — the next person at a shared front-desk PC must never see the
// previous user's lists, even for the fifteen seconds a query stays fresh (UC-IDENTITY-003, BR-IDENTITY-005; H2).
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false, staleTime: 15_000 } } });
